<template lang="pug">
  div
    p.mb-3.label.basic600--text.text-uppercase {{ $t('address_1.label') }}
    v-text-field.p1(background-color="basic200" height="40" v-model="address.address_1" :placeholder="$t('address_1.placeholder')" outlined dense :rules="rules.not_empty")
    p.mb-3.label.basic600--text.text-uppercase {{ $t('address_2.label') }}
    v-text-field.p1(background-color="basic200" height="40" v-model="address.address_2" :placeholder="$t('address_2.placeholder')" outlined dense :rules="rules.not_empty")
    p.mb-3.label.basic600--text.text-uppercase {{ $t('postcode.label') }}
    v-text-field.p1(background-color="basic200" height="40" v-model="address.postcode" :placeholder="$t('postcode.placeholder')" outlined dense :rules="rules.not_empty" @keyup="fetchPostcodes(address.postcode)")
    p.mb-3.label.basic600--text.text-uppercase {{ $t('city.label') }}
    v-text-field.p1(background-color="basic200" height="40" v-model="address.city" :placeholder="$t('city.placeholder')" outlined dense :rules="rules.not_empty" :loading="isLoading")
    p.mb-3.label.basic600--text.text-uppercase {{ $t('state.label') }}
    v-text-field.p1(background-color="basic200" height="40" v-model="address.state" :placeholder="$t('state.placeholder')" outlined dense :rules="rules.not_empty" :loading="isLoading")
    p.mb-3.label.basic600--text.text-uppercase {{ $t('country.label') }}
    v-text-field.p1(background-color="basic200" height="40" v-model="address.country" :placeholder="$t('country.placeholder')" outlined dense :rules="rules.not_empty" :loading="isLoading")
</template>

<script>
export default {
  name: 'AddressInputs',
  props: ['parentAddress', 'autofillPostcode'],
  data: () => ({
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    }
  }),
  computed: {
    address: {
      get () {
        return this.parentAddress
      },
      set (newValue) {
        this.$emit('update:parentAddress', newValue)
      }
    }
  },
  methods: {
    fetchPostcodes (val) {
      if (!val) {
        return
      }
      if (val.length !== 5) {
        return
      }
      if (!this.autofillPostcode) {
        return
      }
      this.isLoading = true
      this.$axios.get(`/shipping/postcodes?postcode=${this.address.postcode}`).then((response) => {
        const addresses = response.data
        if (addresses.length > 0 && addresses[0].postcode) {
          this.$set(this.address, 'city', addresses[0].city)
          this.$set(this.address, 'state', addresses[0].state)
          this.$set(this.address, 'country', addresses[0].country)
        }
      })
      .catch(() => {
      })
      .finally(() => {
        this.isLoading = false
      })
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    }
  },
  "id": {
    "address_1": {
      "label": "Nama Jalan, Gedung, No Rumah, RT/RW, Kelurahan",
      "placeholder": "e.g. Jalan Prof. Joko Sutono Sh No.999, RT.14/RW.6, Petogogan, "
    },
    "address_2": {
      "label": "Kecamatan",
      "placeholder": "Kec. Kby. Baru"
    },
    "postcode": {
      "label": "Kode Pos",
      "placeholder": "12160"
    },
    "city": {
      "label": "Kota",
      "placeholder": "Kota Jakarta Selatan"
    },
    "state": {
      "label": "Provinsi",
      "placeholder": "DKI Jakarta"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Indonesia"
    }
  }
}
</i18n>